import { useState } from 'react';
import { Map } from 'immutable';
import { ApiConfiguration } from '../config/ApiConfiguration';
import 'ag-grid-enterprise';

export const useStatistics = () => {
    const [records, setRecords] = useState([]);
    const [ipLocationMap, setIpLocationMap] = useState(Map());

    const getRecord = () => {
        fetch(...ApiConfiguration.getRecord())
            .then(r => r.json())
            .then(data => setRecords(data.records));
    };

    const getBatchIpLocations = () => {
        fetch(...ApiConfiguration.externalGetBatchIpLocations(records))
            .then(r => r.json())
            .then(data => {
                setIpLocationMap(
                    data.reduce((acc, curr) => acc.set(curr.query, curr), Map())
                );
            });
    };

    const onGridReady = (e) => {
        e.api.applyColumnState({
            state: [
                {
                    colId: 'nyDate',
                    sort: 'asc',
                }
            ]
        });
    };
    
    const getRowStyle = (params) => {
        return {backgroundColor: params.rowIndex % 2 === 0 ? '#dadada' : '#b4b4b4'};
    };

    const context = {
        ipLocationMap: ipLocationMap,
    };

    return {
        records,
        getRowStyle,
        context,
        onGridReady,
        getRecord,
        getBatchIpLocations,
    };
};